<template>
  <div v-if="selectedPolicy && isOpen">
    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vuemodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Waiting Time ({{ selectedPolicy.policyTitle }})</h4>
                <h6>
                  Last Updated: {{ model.modifiedDate ? model.modifiedDate.stringFullDate : '-' }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="row">
                      <!-- Start: Form -->
                      <div class="col-sm-3 divider-right pr-25">
                        <div class="form-group">
                          <label class="required">Source Type</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error': isSubmitted && $v.model.type.$error,
                            }"
                            placeholder=""
                            label="text"
                            v-model="model.type"
                            :options="sourceTypes"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.value"
                          ></v-select>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.type.required"
                            >Type is required</small
                          >
                        </div>
                        <div class="form-group">
                          <label class="required">
                            Allowed Time
                            <span class="--grey50">(minute)</span>
                          </label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.totalMinuteAllowed.$error,
                            }"
                            type="number"
                            v-model="model.totalMinuteAllowed"
                            placeholder="Number"
                          />
                          <div v-if="isSubmitted && $v.model.totalMinuteAllowed.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.totalMinuteAllowed.required"
                              >Total Minutes is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.totalMinuteAllowed.minValue"
                              >Min total minutes is
                              {{
                                $v.model.totalMinuteAllowed.$params.minValue.min
                              }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">
                            Rate
                            <span class="--grey50" v-if="moneyFormat"
                              >({{ moneyFormat.currencyCode }})</span
                            >
                          </label>
                          <currency-input
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.model.rate.$error,
                            }"
                            autocomplete="off"
                            v-model="model.rate"
                            placeholder="Enter rate"
                            :allow-negative="false"
                            :currency="null"
                            :locale="moneyFormat.cultureCode"
                            :precision="moneyFormat.numberOfDecimal"
                          />
                          <div v-if="isSubmitted && $v.model.rate.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.required"
                              >Rate is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.minValue"
                              >Min rate is {{ $v.model.rate.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div
                          class="modal-footer"
                          v-if="isAllowToCreate || isAllowToUpdate"
                        >
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="reset()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                      <!-- End: Form -->
                      <!-- Start: Table -->
                      <div class="col-sm-9 divider-left pl-20">
                        <div class="table-modal-detail">
                          <div class="table-responsive table-accordion">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th class="number">No</th>
                                  <th>Source</th>
                                  <th class="text-center">Allowed Time (minute)</th>
                                  <th class="text-right">
                                    Rate
                                    <span class="--grey50" v-if="moneyFormat">
                                      ({{ moneyFormat.currencyCode }})
                                    </span>
                                  </th>
                                  <th class="text-center">Status</th>
                                  <th class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in items" :key="item.id">
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td>{{ humanize(item.type) }}</td>
                                  <td class="text-center">
                                    {{ item.totalMinuteAllowed }}
                                  </td>
                                  <td class="text-right">{{ printMoney(item.rate) }}</td>
                                  <td class="text-center">
                                    <label class="cursor-pointer">
                                      <input
                                        type="checkbox"
                                        class="control-checkbox"
                                        v-model="item.isActive"
                                        :disabled="!isAllowToUpdate"
                                        @change="changeStatus(item)"
                                      />
                                      <span class="pl-5 font-weight-normal v-align-middle">
                                        {{ item.isActive ? "Active" : "Inactive" }}
                                      </span>
                                    </label>
                                  </td>
                                  <td class="text-center">
                                    <div class="button-action-wrapper">
                                      <button
                                        v-if="isAllowToUpdate"
                                        class="btn btn-default"
                                        type="button"
                                        @click="bindModel(item)"
                                      >
                                        <span>Edit</span>
                                      </button>
                                      <button
                                        v-if="isAllowToDelete"
                                        class="btn btn-default"
                                        type="button"
                                        @click="confirmDelete(item.id)"
                                      >
                                        <i class="ic-close"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- End: Table -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import buyingTariffWaitingTimeSurchargeService from "@/services/master/buyingTariff/buyingTariffOverriddenWaitingTimeSurchargeService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isSubmitted: false,
      isOpen: false,
      rentalLabel: null,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedPolicy: null,
      itemToBeDeleted: null,
      sourceTypes: [],
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        type: { required },
        totalMinuteAllowed: { required, minValue: minValue(0) },
        rate: { required, minValue: minValue(0) },
      },
    };
  },
  async created() {
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );

    this.$eventBus.$on(
      "initializeBuyingTariffOverriddenWaitingTimeSurcharge",
      this.initialize
    );
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffOverriddenWaitingTimeSurcharge");
  },
  methods: {
    async initialize(policy) {
      try {
        this.isLoading = true;
        this.isOpen = true;
        this.selectedPolicy = policy;
        this.moneyFormat = policy.moneyFormat;
        this.formatter = new Intl.NumberFormat(policy.moneyFormat.cultureCode, {
          style: "currency",
          currency: policy.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: policy.moneyFormat.numberOfDecimal,
        });
        this.reset();
        this.sourceTypes = [
          { text: "Airport Transfer (Arrival)", value: "ArrivalAirportTransfer" },
          {
            text: "Airport Transfer (Departure)",
            value: "DepartureAirportTransfer",
          },
          { text: "In-Town Transfer", value: "InTownTransfer" },
          {
            text: this.rentalLabel,
            value: "Rental",
          },
        ];

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions =
          profile.services["BuyingTariffOverriddenWaitingTimeSurcharge"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          await this.getAll();
        }

        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    openModal() {
      $(this.$refs.vuemodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    closeModal() {
      $(this.$refs.vuemodal).modal("hide");
      this.isOpen = false;
    },
    resetValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    bindModel(object) {
      this.isUpdate = true;
      this.resetValidation();
      this.model = Object.assign({}, object);
    },
    reset() {
      this.isUpdate = false;
      this.resetValidation();
      this.model = {};
    },
    async getAll() {
      this.items = await buyingTariffWaitingTimeSurchargeService.getAll(
        this.selectedPolicy.policyId
      );
    },
    fixNumber() {
      this.model.totalMinuteAllowed = parseInt(this.model.totalMinuteAllowed);
      this.model.rate = parseFloat(this.model.rate);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.policyId = this.selectedPolicy.policyId;
        this.fixNumber();
        if (!this.isUpdate) {
          await buyingTariffWaitingTimeSurchargeService.create(this.model);
          this.$notification.success("Successfully added.", { title: "Success" });
        } else {
          await buyingTariffWaitingTimeSurchargeService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        }
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await buyingTariffWaitingTimeSurchargeService.update(item);
        this.$notification.success("Successfully updated.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await buyingTariffWaitingTimeSurchargeService.delete(this.itemToBeDeleted);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        this.isItemHasBeenModified = true;
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printMoney(value) {
      return this.formatter !== null
        ? this.formatter
            .format(value)
            .replace(/[a-z]{3}/i, "")
            .trim()
        : value;
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/OverriddenWaitingTimeSurcharge.vue